export default __webpack_public_path__ + "static/media/work1.63a3abd5.svg";